import { NetworkActionPrefix, ActionType } from '../utils/constants';
import { ContentWatchSettingsApi, NewsEntryAutomatedSourceApi } from 'for-straction-service-api'
import { networkAPIAction, entityLifecycleActionSet } from '../utils/actionCreatorsFactory';
import { isInternalID } from '../api/utils';

const watchAPI = new ContentWatchSettingsApi();

const watches = {
    loadWatchSettingsList() {
        return networkAPIAction(watchAPI, 'contentWatchSettingsLoadAllGet', NetworkActionPrefix.LOAD_MARKET_WATCH_LIST_PREFIX, null);
    },
    loadWatchSettings(type, watchID) {
        return networkAPIAction(watchAPI, 'contentWatchSettingsLoadGet', NetworkActionPrefix.LOAD_MARKET_WATCH_PREFIX, {
            watchType: type,
            watchID
        }, type, watchID);
    },
    editWatchSettings: (watchType, watchID) => ({ type: ActionType.EDIT_MARKET_WATCH, watchType, watchID }),
    setWatchSettingsURL: (URL) => ({ type: ActionType.SET_MARKET_WATCH_URL, URL }),
    setWatchSettingsType: (watchType) => ({ type: ActionType.SET_MARKET_WATCH_TYPE, watchType }),
    setWatchSettingsName: (name) => ({ type: ActionType.SET_MARKET_WATCH_NAME, name }),
    setWatchSettingsSelector: (selector) => ({ type: ActionType.SET_MARKET_WATCH_SELECTOR, selector }),
    setWatchSettingsModerator: (moderatorID) => ({ type: ActionType.SET_MARKET_WATCH_MODERATOR, moderatorID }),
    loadWatchSettingsURL(url, promise) {
        // TODO maybe split to separate actions instead of passing promise?
        return dispatch => {
            dispatch({
                type: ActionType.LOAD_MARKET_WATCH_URL_PENDING,
                URL: url
            });

            promise.then(
                () => dispatch({
                    type: ActionType.LOAD_MARKET_WATCH_URL_SUCCESS,
                    URL: url
                }),
                () => dispatch({
                    type: ActionType.LOAD_MARKET_WATCH_URL_FAIL,
                    URL: url
                })
            );
        }
    },
    setWatchSettingsPESTELArea: (pestelAreaID) => ({ type: ActionType.SET_MARKET_WATCH_PESTEL_AREA, pestelAreaID }),
    setWatchSettingsSWOTTopic: (swotTopicID) => ({ type: ActionType.SET_MARKET_WATCH_SWOT_TOPIC, swotTopicID }),
    setWatchSettingsPersonalTopic: (personalTopicID) => ({ type: ActionType.SET_MARKET_WATCH_PERSONAL_TOPIC, personalTopicID }),
    setWatchSettingsTrendTopic: (trendTopicID) => ({ type: ActionType.SET_MARKET_WATCH_TREND_TOPIC, trendTopicID }),
    setWatchSettingsStakeholderID: (stakeholderID) => ({ type: ActionType.SET_MARKET_WATCH_STAKEHOLDER_ID, stakeholderID }),
    setWatchSettingsCompanyLegalEntityID: (companyLegalEntityID) => ({ type: ActionType.SET_MARKET_WATCH_COMPANY_LEGAL_ENTITY_ID, companyLegalEntityID }),
    setWatchSettingsCompanyFunctionID: (companyFunctionID) => ({ type: ActionType.SET_MARKET_WATCH_COMPANY_FUNCTION_ID, companyFunctionID }),
    setWatchSettingsSuggestions: (suggestions) => ({ type: ActionType.SET_MARKET_WATCH_SUGGESTIONS, suggestions }),
    setWatchSettingsHighlightSelector: (selector) => ({ type: ActionType.SET_MARKET_WATCH_HIGHLIGHT_SELECTOR, selector }),
    setWatchSettingsExtend: (extend) => ({ type: ActionType.SET_MARKET_WATCH_EXTEND, extend }),
    syncWatchSettings(watch) {
        if (isInternalID(watch.WatchID)) {
            return networkAPIAction(watchAPI, 'contentWatchSettingsAddPut', NetworkActionPrefix.ADD_MARKET_WATCH_PREFIX, {
                watchType: watch.Type,
                watchID: watch.WatchID,
                watch
            }, watch);
        }
        else {
            return networkAPIAction(watchAPI, 'contentWatchSettingsEditPut', NetworkActionPrefix.EDIT_MARKET_WATCH_PREFIX, {
                watchType: watch.Type,
                watchID: watch.WatchID,
                watch
            }, watch, watch.WatchID);
        }
    },
    saveWatchSettings(watchType, watchID, watch) {
        return (dispatch, getState) => {
            dispatch({ type: ActionType.SAVE_MARKET_WATCH, watchType, watchID, watch });

            return dispatch(watches.syncWatchSettings(watch));
        }
    },
    deleteMarketWatchSetting(watch) {
        return networkAPIAction(watchAPI, 'contentWatchSettingsDeletePut', NetworkActionPrefix.DELETE_MARKET_WATCH_PREFIX, {
            watchType: watch.Type,
            watchID: watch.WatchID,
            watch
        }, watch)
    },
    showMarketWatchDetails: ID => ({ type: ActionType.SHOW_MARKET_WATCH_DETAILS, ID }),
    closeMarketWatchDetails: () => ({ type: ActionType.CLOSE_MARKET_WATCH_DETAILS }),
    marketWatchChangeDetailModalContent: contentType => ({ type: ActionType.MARKET_WATCH_CHANGE_DETAIL_MODAL_CONTENT, detailModalContent: contentType }),
};

export default watches;